module.exports = __webpack_public_path__ + "be0329294bcc1ceca7a28dfc83cd1606.png";